export default __webpack_public_path__ + "232bb8a5626db97539f191626a18e700.png";